var iterate = require('../internals/iterate');

var createProperty = require('../internals/create-property'); // `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries


require('../internals/export')({
  target: 'Object',
  stat: true
}, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, undefined, true);
    return obj;
  }
});